import TextField from '@betterfunnel/ui-core/TextField';
import { DocumentDuplicateIcon } from '@heroicons/react/24/outline';
import { useState } from 'react';

interface Props {
  title?: string;
  text: string;
}

export default function CopyTextField({ title, text }: Props) {
  const [copied, setCopied] = useState(false);

  return (
    <TextField
      title={title}
      value={text}
      readOnly
      endIcon={
        copied ? (
          <span className="text-sm text-green-600">Copied!</span>
        ) : (
          <DocumentDuplicateIcon className="h-4 w-4" />
        )
      }
      onClick={() => {
        setCopied(true);
        navigator.clipboard.writeText(text);
      }}
    />
  );
}
